import script from "./MasterCalendar.vue?vue&type=script&setup=true&lang=ts"
export * from "./MasterCalendar.vue?vue&type=script&setup=true&lang=ts"

import "./MasterCalendar.vue?vue&type=style&index=0&id=71794250&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71794250"]])

export default __exports__